import FormItem from "components/Form/FormItem";
import Input from "shared/Input/Input";
import Textarea from "shared/Textarea/Textarea";
import GoogleMapReact from "google-map-react";
import LocationMarker from "components/AnyReactComponent/LocationMarker";
import { FC, useEffect, useState } from "react";
import Loader from "react-loader-spinner";
import { useDispatch } from "react-redux";
import { updateFormTrip, updateFormTripMass } from "functions/redux/listing/action";
import Geocode from "react-geocode";
import { getCountryByCode } from "functions/redux/country/action";
import { showAlert } from "functions/redux/general/action";
import { modalContent } from "containers/PageSignUp/PageSignUp";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import ncNanoId from "utils/ncNanoId";
import usePlacesAutocomplete, {
    getGeocode,
    getLatLng,
} from 'use-places-autocomplete';

interface location {
    locationName: any,
    lat: any,
    lng: string,
    placeId: string,
    country: any
}


interface OpenStopProps {
    form: any
}
const OpenStepTwo: FC<OpenStopProps> = ({ form }) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const [placeLoading, setPlaceLoading] = useState(false);
    const {
        ready,
        value: place,
        suggestions: { status, data: suggestionsData },
        setValue: setPlace,
        clearSuggestions,
    } = usePlacesAutocomplete({
        defaultValue: "",
        debounce: 300,
    });
    const [locations, setLocations] = useState<location[]>(form?.productLocation ?? []);
    
    const handleSelect = (address: string) => {
        setPlaceLoading(true);
        setPlace(address, false);
        clearSuggestions();
        getGeocode({ address })
            .then(async (results: any) => {
                var latLng = await getLatLng(results[0]);
                Geocode.fromLatLng(latLng.lat, latLng.lng).then(
                    async (params: any) => {
                        let country;

                        params.results.forEach((item: any, k: any) => {
                            if (item.types[0] === 'country') {
                                country = item.address_components[0].short_name;
                            }
                        });

                        if (country !== undefined) {
                            var res = await getCountryByCode(country);
                            if (res.length > 0 || res.id) {
                                var find = locations.find(o => o.placeId === results[0].place_id);
                                if (find === undefined) {
                                    locations.push({
                                        locationName: address,
                                        placeId: results[0].place_id,
                                        lat: latLng.lat,
                                        lng: latLng.lng.toString(),
                                        country: res?.id ? res.id : res[0].id
                                    });

                                    dispatch(updateFormTrip('productLocation', locations));
                                    form.locations = form.locations ?? [];
                                }
                            } else {
                                dispatch(showAlert(modalContent(t('country_not_supported')), "Warning!", true))
                            }

                            setPlace("", false);
                            setPlaceLoading(false);
                        } else {
                            dispatch(showAlert(modalContent(t('country_not_supported')), "Warning!", true))

                            setPlace("", false);
                            setPlaceLoading(false);
                        }

                    }
                )

            })
            .catch((error: any) => {
                console.error('Error', error);
                setPlaceLoading(false);
            });
    };

    
    const findArrayIndex = (item: any) => {
        var nilai = 0;
      var innn:any =  locations.findIndex((o, index) => {
          if (nilai > 0) {
              return false;
          }
        if ((o.locationName === item) && item !== undefined && o.locationName !== undefined) {
            nilai =  index
        }
            // return false;
       });
       return nilai;
       
    }


    const removePlace = (placeId: string) => {
        const index = findArrayIndex(placeId);
        locations.splice(index, 1);
        dispatch(updateFormTrip('productLocation', locations));
        // var index: any = locations.find((o, index) => {
        //     if ((o.placeId === placeId) !== undefined) {
        //         return index
        //     } else {
        //         return false;
        //     }
        // });
        // if (index !== false) {
        //     locations.splice(index, 1);
        //     dispatch(updateFormTrip('productLocation', locations));
        // }

    }

    const renderPlaces: FC<{ getInputProps: any, getSuggestionItemProps: any, suggestions: any }> = ({ getInputProps, getSuggestionItemProps, suggestions }) => (
        
        <div className="autocomplete-root">
            <FormItem label={t('form_loc_dest') + "*"}>
                <div className="relative">
                    <Input {...getInputProps()} className="mt-2" placeholder={t('find_place')} />
                    <div className="absolute inset-y-0 right-2 pr-3 flex items-center pointer-events-none">
                        {placeLoading ? <Loader
                            type="Circles"
                            color="#d24e29"
                            height={25}
                            width={25}
                        /> : <></>}
                    </div>
                </div>
            </FormItem>
            <div className="autocomplete-dropdown-container">
                {suggestions.map((suggestion: any) => (
                    <span key={ncNanoId()}{...getSuggestionItemProps(suggestion)} style={{cursor:'pointer'}} className="flex items-center justify-between py-3">
                        <span className="text-neutral-6000 dark:text-neutral-400 font-medium">
                            {suggestion.description}
                        </span>
                    </span>
                ))}
            </div>
        </div>
    )


    const renderSelectedPlaces = (location: location) => {
        return (<div key={ncNanoId()} className="flex items-center justify-between py-3">
            <span className="text-neutral-6000 dark:text-neutral-400 font-medium">
                {location.locationName}
            </span>
            <span style={{cursor:'pointer'}} onClick={() => removePlace(location.locationName)}>
                <i className="text-2xl text-neutral-400 las la-times-circle hover:text-neutral-900 dark:hover:text-neutral-100 cursor-pointer"></i>
            </span>
        </div>);
    }

    return (<>
        <h2 className="text-2xl font-semibold">{t('more_about_trip')}</h2>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
        <div className="space-y-8 block">
            <FormItem
                label={t('highlight') + "*"}
                desc={t('highlight_desc')}
            >
                <Input value={form?.highlight ?? ''} onChange={(e) => dispatch(updateFormTrip('highlight', e.target.value))} />
            </FormItem>
            <FormItem
                label={t('description') + "*"}
                desc={t('description_desc')}
            >
                <Textarea value={form?.description ?? ''} placeholder="..." rows={3} onChange={(e) => dispatch(updateFormTrip('description', e.target.value))} />
            </FormItem>
            {/* <FormItem
                label={t('add_contact_person') + "*"}
                desc={t('add_contact_person_desc')}
            >
                <Input value={form?.additionalContact ?? ''} onChange={(e) => dispatch(updateFormTrip('additionalContact', e.target.value))} />
            </FormItem> */}

            <div className="autocomplete-root">
                <FormItem label={t('form_loc_dest') + "*"}>
                    <div className="relative">
                        <Input
                            value={place}
                            onChange={(e) => setPlace(e.target.value)}
                            disabled={!ready}
                            className="mt-2"
                            placeholder={t('find_place')}
                        />
                        <div className="absolute inset-y-0 right-2 pr-3 flex items-center pointer-events-none">
                            {placeLoading ? <Loader
                                type="Circles"
                                color="#d24e29"
                                height={25}
                                width={25}
                            /> : <></>}
                        </div>
                    </div>
                </FormItem>
                {status === "OK" && (
                    <div className="autocomplete-dropdown-container bg-white dark:bg-neutral-800 border border-neutral-200 dark:border-neutral-700 rounded-xl mt-1 shadow-lg overflow-hidden z-20 relative">
                        {suggestionsData.map((suggestion: any) => (
                            <div
                                key={suggestion.place_id}
                                onClick={() => handleSelect(suggestion.description)}
                                className="flex items-center justify-between py-3 px-4 hover:bg-neutral-100 dark:hover:bg-neutral-700 cursor-pointer transition-colors"
                            >
                                <span className="text-neutral-700 dark:text-neutral-300 font-medium text-sm">
                                    {suggestion.description}
                                </span>
                            </div>
                        ))}
                    </div>
                )}
            </div>
            {locations.length > 0 ?
                <div className="flow-root px-4">
                    <div className="-my-3 divide-y divide-neutral-100 dark:divide-neutral-800">
                        {locations.map((item) => renderSelectedPlaces(item))}
                    </div>
                </div> : <></>}
        </div >
    </>);
}

export default OpenStepTwo;